import { NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { GabaritoComponent } from '../../../subPages/gabarito/gabarito.component';
import { CommentsComponent } from '../../../subPages/comments/comments.component';
import { StatisticsComponent } from '../../../subPages/statistics/statistics.component';
import { QuestionService } from '../../../services/question.service';
import { hasAnsweredResponse, Like, LikesResponse, simpleResponse } from '../../../models/question.model';
import Swal from 'sweetalert2';
import { FormsModule } from '@angular/forms';  // Importação do FormsModule
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-question',
  standalone: true,
  imports: [NgIf, GabaritoComponent, CommentsComponent, StatisticsComponent, NgClass, FormsModule, RouterLink],  
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss']  
})
export class QuestionComponent {
  isMoreContainerVisible: boolean = false;
  hasAnswered: boolean = false;
  isLastAnswerRight: string = '';
  activeComponent: string | null = null;
  isLiked: boolean | null = null;
  selectedAlternative: any;
  showResultMsg: boolean = false;
  msg: string = '';
  msg_style: string = '';
  likes: Like[] = [];
  @Input() qcode: string | undefined;
 removedAlternatives: boolean[] = [false, false, false, false, false];
 isAnswered: boolean = false;
 isCorrect: boolean = false;


 correct_msg: string[] = [
  '🎉 Parabéns, você acertou!',
  '✅ Resposta correta, ótimo trabalho!',
  '👏 Você acertou! Continue assim!',
  '🌟 Excelente, sua resposta está correta!',
  '👍 Muito bem, você fez a escolha certa!',
  '🎯 Acertou em cheio! Continue assim!',
  '🏆 Resposta certa! Você está mandando bem!',
  '🙌 Você acertou! Que incrível!',
  '✔️ Correto! Você está indo muito bem!',
  '🥳 Parabéns! Resposta correta!',
  '🔥 Isso mesmo! Você está arrasando!',
  '💡 Boa! Você pensou certinho!',
  '✅ Acerto perfeito! Continue focado!',
  '👏 Muito bom! Você está no caminho certo!',
  '🎉 Uau! Resposta certinha!',
  '👍 Você fez a escolha certa, parabéns!'
];

  not_correct_msg: string[] = [
    '❌ Ops, essa não é a resposta correta.',
    '🚫 Você errou, tente novamente!',
    '😕 Não foi dessa vez, continue tentando!',
    '🔴 Resposta incorreta, mas não desista!',
    '🙁 Quase lá, mas ainda não acertou.',
    '⚠️ Essa não é a resposta certa, revise e tente de novo.',
    '😔 Infelizmente, você errou. Que tal tentar outra vez?',
    '❗ Resposta errada. Vamos tentar de novo?',
    '💡 Não é bem isso. Dê mais uma olhada!',
    '😅 Essa não está certa. Tente novamente!',
    '🙃 Não foi a resposta correta, mas você consegue!',
    '🔍 Errou dessa vez, mas continue focado!',
    '🤔 Não é a resposta certa, mas você está no caminho!',
    '😓 Não deu certo agora, mas tente outra vez!',
    '📛 Resposta incorreta. Vamos tentar mais uma?'
  ];



  constructor(private questionService: QuestionService) {}

  @Input() question: any;
  
  ngOnInit(){
    //getting user likes
    this.questionService.getUserLikes().subscribe((response: LikesResponse)=>{
    this.likes = response.likes;
    this.isLiked = this.likes.some(like => like.qcode === this.question.code);
    });

     //getting last answers
     this.questionService.hasAnswered(this.question.code).subscribe((response: hasAnsweredResponse)=>{
      this.hasAnswered = response.hasAnswered;
      this.isLastAnswerRight = response.isCorrectlastAnswer === true ? 'hasTrue' : 'hasFalse';
      });
  }
  
  toggleMoreContainer(component: string) {
    if (this.activeComponent === component && this.isMoreContainerVisible) {
      this.isMoreContainerVisible = false;
      this.activeComponent = null;
    } else {
      this.isMoreContainerVisible = true;
      this.activeComponent = component;
    }
  }

  toggleLike(qcode: string) {
    this.questionService.toggleLike(qcode).subscribe(
      (response: simpleResponse) => {
        this.isLiked = true;
        if (response.message === 'Like added successfully') {
          Swal.fire({
            text: 'Curtida Salva!',
            icon: 'success',
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true
          });
        } else if (response.message === 'Like removed successfully') {
          this.isLiked = false;
          Swal.fire({
            text: 'Curtida Removida!',
            icon: 'success',
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true
          });
        }
      },
      (error) => {
        console.error('Error toggling like:', error);
      }
    );
  }

  postFeedback(qcode: string) {
    Swal.fire({
      input: "textarea",
      inputLabel: "Escreva seu Feedback!",
      showLoaderOnConfirm: true,
      inputPlaceholder: "Escreva sua mensagem aqui!",
      showCancelButton: true,
      customClass: {
        confirmButton: 'btn-confirm',
        cancelButton: 'btn-cancel'
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const feedback = result.value;

        this.questionService.postFeedback(qcode, feedback).subscribe((response) => {
          if (response.status === true) {
            Swal.fire({
              text: 'Feedback enviado, muito obrigado!',
              icon: 'success',
              toast: true,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true
            });
          } else {
            this.isLiked = false;
            Swal.fire({
              text: 'Algo deu errado',
              icon: 'error',
              toast: true,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true
            });
          }
        });
      }
    });
  }

  onAnswerSubmit(event: Event, qcode: string): void {
    event.preventDefault();
    const button = event.target as HTMLButtonElement;
    button.innerHTML = 'Validando...';
    button.disabled = true;
  
    this.questionService.validateAnswer(qcode, this.selectedAlternative).subscribe({
      next: (response: simpleResponse) => {
        this.isAnswered = true;
        
        if (response.message === 'correct' && response.status === true) {
          this.isCorrect = true;
          this.msg = this.correct_msg[Math.floor(Math.random() * 15)];
          this.msg_style = 'mt-5 bg-green-300 text-green-800 p-2 w-fit rounded-xl animate__animated animate__fadeIn';
          this.toggleMoreContainer('Gabarito')
        } else {
          this.isCorrect = false;
          this.msg = this.not_correct_msg[Math.floor(Math.random() * 15)];
          this.msg_style = 'mt-5 bg-red-200 text-red-800 p-2 w-fit rounded-xl animate__animated animate__shakeX';
          this.toggleMoreContainer('Gabarito')
        }
        
        this.showResultMsg = true;
        button.classList.add('notClick');
        button.innerHTML = 'Respondido';
      },
      error: (err) => {
        console.error('Erro na validação:', err);
        button.disabled = false;
        button.innerHTML = 'Tentar novamente';
      }
    });
  }

 // ... outras propriedades e métodos

 toggleRemoved(index: number) {
  this.removedAlternatives[index] = !this.removedAlternatives[index];
}
}
